import Chip from "@mui/material/Chip";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import { COUNTRIES, COUNTRY_META, getCountry, switchCountry, type Country } from "../lib/country";
import { useI18n } from "../lib/i18n";
import type { User } from "../lib/types";

/**
 * Chuyển quốc gia đang thao tác.
 *
 * - **superadmin**: nút gạt 2 quốc gia; đổi xong tải lại trang để không màn hình
 *   nào còn giữ dữ liệu quốc gia cũ.
 * - vai trò khác: chỉ hiện nhãn quốc gia của tài khoản (API khoá cứng, không đổi
 *   được) — hiện ra để người dùng biết mình đang xem dữ liệu nước nào.
 */
export function CountrySwitch({ user }: { user: User }) {
  const { t } = useI18n();
  const current = user.canSwitchCountry ? getCountry() : ((user.country ?? "vn") as Country);
  const meta = COUNTRY_META[current];

  if (!user.canSwitchCountry) {
    return (
      <Tooltip title={t("country.lockedHint")}>
        <Chip
          size="small"
          variant="outlined"
          label={`${meta.flag} ${meta.label}`}
          sx={{ alignSelf: "flex-start", fontSize: 11.5 }}
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t("country.switchHint")}>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={current}
        onChange={(_e, next) => next && switchCountry(next as Country)}
        aria-label={t("country.label")}
        fullWidth
      >
        {COUNTRIES.map(c => (
          <ToggleButton key={c} value={c} sx={{ fontSize: 11.5, gap: 0.5 }}>
            <span aria-hidden>{COUNTRY_META[c].flag}</span>
            {c.toUpperCase()}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Tooltip>
  );
}
